if (!customElements.get('newsletter-modal')) {
  customElements.define(
    'newsletter-modal',
    class NewsletterModal extends ModalElement {
      constructor() {
        super();
    
        // Prevent popup on Shopify robot challenge page
        if (window.location.pathname === '/challenge' || !theme.cookiesEnabled()) {
          return;
        }
    
        if (!theme.config.isTouch || Shopify.designMode) {
          this.init();
        }
        else {
          new theme.initWhenVisible(theme.utils.throttle(this.init.bind(this)));
        }
      }
    
      get shouldLock() {
        return true;
      }
    
      get testMode() {
        return this.getAttribute('data-test-mode') === 'true';
      }
    
      get delay() {
        return this.hasAttribute('data-delay') ? parseInt(this.getAttribute('data-delay')) : 5;
      }
    
      get expiry() {
        return this.hasAttribute('data-expiry') ? parseInt(this.getAttribute('data-expiry')) : 30;
      }
    
      get cookieName() {
        return 'concept:newsletter-popup';
      }
    
      get submited() {
        return this.querySelector('.alert') !== null;
      }
    
      init() {
        if (this.initialized) return;
        this.initialized = true;
        
        // Open modal if errors or success message exist
        if (this.submited) {
          this.load(1);
          return;
        }
    
        if (this.testMode || !this.getCookie(this.cookieName)) {
          this.load(this.delay);
        }
      }
    
      load(delay) {
        if (Shopify.designMode) return;
    
        if (this.submited) {
          setTimeout(() => this.show(), delay * 1000);
          return;
        }
        if (theme.config.isTouch || window.matchMedia('(max-width: 1023px)').matches) return;
        setTimeout(() => this.tryAutoShow(), Math.max(delay, 45) * 1000);
      }
    
      tryAutoShow() {
        if (!this.isConnected || this.autoOpened || this.hasAttribute('open') || window.matchMedia('(max-width: 1023px)').matches) return;
        if (!this.testMode && this.getCookie(this.cookieName)) return;
        const consent = window.Shopify.customerPrivacy?.getTrackingConsent();
        const decisionMade = consent === 'yes' || consent === 'no';
        const dialogOpen = document.querySelector('modal-element[open], menu-drawer[open], cart-drawer[open], search-drawer[open], cookie-banner[open], dialog[open], [role="dialog"][aria-modal="true"]:not([hidden]), #rapid-search-results.search-results-mobile');
        const userTyping = document.activeElement?.matches('input, textarea, select, [contenteditable="true"]');
        if (!decisionMade || dialogOpen || document.body.classList.contains('has-modal-open') || userTyping || document.hidden) {
          this.autoRetry = setTimeout(() => this.tryAutoShow(), 15000);
          return;
        }
        this.autoOpened = true;
        this.show();
      }

      disconnectedCallback() {
        clearTimeout(this.autoRetry);
        super.disconnectedCallback();
      }

      afterShow() {
        super.afterShow();
        this.classList.add('show-image');
      }
    
      afterHide() {
        super.afterHide();
        this.classList.remove('show-image');
    
        // Remove a cookie in case it was set in test mode
        if (this.testMode) {
          this.removeCookie(this.cookieName);
          return;
        }
    
        this.setCookie(this.cookieName, this.expiry);
      }
    
      getCookie(name) {
        const match = document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`);
        return match ? match[2] : null;
      }
    
      setCookie(name, expiry) {
        document.cookie = `${name}=true; max-age=${(expiry * 24 * 60 * 60)}; path=/`;
      }
    
      removeCookie(name) {
        document.cookie = `${name}=; max-age=0`;
      }
    }
  );
}
